import React from 'react'
// import Link
import { Link } from 'react-router-dom'
// import Icon
import Map from "../../assets/img/icon/sm-location.png"
import Mail from "../../assets/img/icon/email-color.png"
import Phone from "../../assets/img/icon/phon-color.png"



const ContactArea = () => {
  return (
    <>
         <section id="contact_arae_main" className="section_padding">
        <div className="container">
            <div className="row">
                <div className="col-lg-6 offset-lg-3 col-md-12 col-sm-12 col-12">
                    <div className="section_heading">
                        <h3>Contact PCF</h3>
                        <h2>Questions on badminton, integration, or
                            <span className="color_big_heading"> culture</span>? We are here
                        </h2>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-6">
                    <div className="contact_area_left">
                        <div className="contact_left_item">
                            <div className="contact_left_icon">
                                <img src={Map} alt="icon" />
                            </div>
                            <div className="contact_left_text">
                                <h3>Address:</h3>
                                <p>PCF — Pakistani Cultural &amp; Sports Organisation <br /> Sweden (venues vary by activity)</p>
                            </div>
                        </div>
                        <div className="contact_left_item">
                            <div className="contact_left_icon">
                                <img src={Mail} alt="icon" />
                            </div>
                            <div className="contact_left_text">
                                <h3>Email:</h3>
                                <Link to="mailto:info@pcfsweden.se">info@pcfsweden.se</Link>
                                <Link to="mailto:volunteer@pcfsweden.se">volunteer@pcfsweden.se</Link>
                            </div>
                        </div>
                        <div className="contact_left_item">
                            <div className="contact_left_icon">
                                <img src={Phone} alt="icon" />
                            </div>
                            <div className="contact_left_text">
                                <h3>Phone:</h3>
                                <Link to="tel:+46701234567">+46 70 123 45 67</Link>
                                <Link to="tel:+46707654321">+46 70 765 43 21</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="contact_form_Wrapper">
                        <h3>Leave us a message</h3>
                        <form action="#!" id="contact_form">
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Your full name*" required />
                            </div>
                            <div className="form-group">
                                <input type="email" className="form-control" placeholder="Your email address*" required />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" placeholder="Subject**" required />
                            </div>
                            <div className="form-group">
                                <textarea className="form-control" rows="6" placeholder="Message*" required></textarea>
                            </div>
                            <div className="contact_submit_form">
                                <button className="btn btn_theme btn_md">Send message</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    </>
  )
}

export default ContactArea